<template>
  <div class="page_wrapper container-fluid teacher_area">
    <div class="row profile_header page_header teacher_header">
      <intern-header />
    </div>
    <div class="row teacher_content">
      <intern-plan-form-content edit-type="edit"/>
    </div>
  </div>
</template>
<script>
import InternHeader from '~components/pages/teachers/InternHeader'
import InternPlanFormContent from '~components/pages/teachers/internForm/InternPlanFormContent'
export default {
  middleware: ['check-auth', 'teacher-auth'],
  name: 'TeachersInternPlanFormEdit',
  routerName: 'TeachersIntern-record:year:eid:sidIntern-plan-formEdit',
  components: {
    InternHeader,
    InternPlanFormContent
  }
}
</script>
